
import React from "react";
import { Check, X } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { Market } from "../markets/marketData";

interface MarketCardProps {
  market: Market;
  toggleMarketActive: (market: Market, isActive: boolean) => Promise<void>;
}

export const MarketCard: React.FC<MarketCardProps> = ({ 
  market, 
  toggleMarketActive 
}) => {
  return (
    <div 
      key={market.country}
      className="border border-gray-200 dark:border-gray-700/50 rounded-lg p-4 flex items-center justify-between bg-white dark:bg-gray-800/40 transition-colors"
    >
      <div className="flex items-center gap-3">
        {market.flagComponent}
        <div>
          <h3 className="font-medium text-gray-800 dark:text-gray-200">
            {market.country}
            {market.isDefault && 
              <span className="ml-2 px-2 py-0.5 text-xs rounded-full bg-custom-primaryLight text-custom-primary dark:bg-custom-primary/20 dark:text-custom-secondaryLight">
                Principal
              </span>
            }
          </h3>
          <p className="text-sm text-gray-500 dark:text-gray-400">
            {market.currency}
          </p>
        </div>
      </div>
      <div className="flex items-center gap-3">
        <div className="flex items-center gap-2">
          <span className={`text-sm font-medium ${market.isActive ? 'text-green-600 dark:text-green-400' : 'text-gray-400 dark:text-gray-500'}`}>
            {market.isActive ? (
              <Check className="h-4 w-4" />
            ) : (
              <X className="h-4 w-4" />
            )}
          </span>
          <span className="text-sm font-medium text-gray-600 dark:text-gray-300">
            {market.isActive ? 'Actif' : 'Inactif'}
          </span>
        </div>
        <Switch 
          checked={market.isActive || false} 
          onCheckedChange={(checked) => toggleMarketActive(market, checked)}
        />
      </div>
    </div>
  );
};
